import styled from '@emotion/styled';

const Container = styled.div`
  font-family: var(--font-Pretendard);
`;

const HeaderContentContainer = styled.div`
  display: flex;
  gap: 20px;
  padding: 0 20px;
  overflow-x: scroll;
  align-items: center;
  background-color: var(--dk-bg, white);
  border-bottom: 1px solid var(--dk-line, #e7e9ec);
  border-top: 5px solid var(--dk-bg, white);
`;

const SubHeaderContentContainer = styled.div`
  padding-top: 110px;
  background-color: var(--dk-bg-subtle, rgb(249, 250, 251));
`;

const BannerLayout = styled.div`
  position: fixed;
  display: flex;
  gap: 8px;
  flex-direction: column;
  right: 20px;
  bottom: 40px;
`;

const HeaderLayout = styled.div<{ showHeader: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transform: ${({ showHeader }) =>
    showHeader ? 'translateY(0)' : 'translateY(-70px)'};
  transition: transform 0.3s ease-in-out;
`;

export {
  Container,
  HeaderContentContainer,
  SubHeaderContentContainer,
  BannerLayout,
  HeaderLayout,
};
